import { UserAuthenticationData } from '../../models/UserAuthenticationData';
import { makeVehicleApiRequest } from '../MakeVehicleApiRequestService/MakeVehicleApiRequestService';

export async function authenticationByVehicleCharacteristics(
	url: string,
	apiKey: string,
	vin: string,
	language: string,
	userAuthenticationData: UserAuthenticationData,
): Promise<{ token: string }> {
	return makeVehicleApiRequest<{ token: string }>({
		url,
		endpoint: 'api/confirmVehicleHolder',
		apiKey,
		body: {
			vin,
			languageCode: language,
			pkn: userAuthenticationData.pkn,
			version: userAuthenticationData.version,
			variant: userAuthenticationData.variant,
		},
	});
}
